export default __webpack_public_path__ + "static/media/1779_bar.b4ab09ad.jpg";